import {
  Award,
  BadgeCheck,
  BadgePercent,
  Banknote,
  Building2,
  Car,
  CheckCircle2,
  Clock,
  CreditCard,
  Fuel,
  Gauge,
  Gem,
  Handshake,
  Headphones,
  Heart,
  Key,
  Landmark,
  MapPin,
  Percent,
  Phone,
  ReceiptText,
  ShieldCheck,
  Sparkles,
  Star,
  Timer,
  TrendingUp,
  Truck,
  Users,
  Wallet,
  Wrench,
  Zap,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

/* The icons the console may choose from.
 *
 * A closed list rather than the whole of Lucide, for two reasons that pull
 * the same way. The console has to draw a picker, and a picker of fifteen
 * hundred icons is not a picker. And the storefront has to ship whatever is
 * pickable — an open list means bundling the entire icon set into a page that
 * currently loads about thirty of them.
 *
 * Thirty-one is enough for a car showroom. Adding one is adding two lines.
 */
export const CMS_ICONS: Record<string, LucideIcon> = {
  Award,
  BadgeCheck,
  BadgePercent,
  Banknote,
  Building2,
  Car,
  CheckCircle2,
  Clock,
  CreditCard,
  Fuel,
  Gauge,
  Gem,
  Handshake,
  Headphones,
  Heart,
  Key,
  Landmark,
  MapPin,
  Percent,
  Phone,
  ReceiptText,
  ShieldCheck,
  Sparkles,
  Star,
  Timer,
  TrendingUp,
  Truck,
  Users,
  Wallet,
  Wrench,
  Zap,
}

/** The icon by that name, or a star — a name that no longer exists must not
    take the section down with it. */
export const cmsIcon = (name: string | undefined): LucideIcon =>
  (name && CMS_ICONS[name]) || Star

/** Every name, for the console's picker. */
export const CMS_ICON_NAMES = Object.keys(CMS_ICONS)
